import { useMemo } from "react";
import type { GetHomeDataResult, MembershipProduct } from "../SpaceType";
import { SpaceHomeCoursePreview } from "./preview/SpaceHomeCoursePreview";
import { SpaceHomeLivePreview } from "./preview/SpaceHomeLivePreview";
import { SpaceHomeViewpointPreview } from "./preview/SpaceHomeViewpointPreview";

/** 产品预览：直播 / 教学视频 / 观点（各一块，有数据才展示） */
export function SpaceHomeProductPreview(props: {
  spaceId: string;
  data: GetHomeDataResult | null;
  membershipProducts: MembershipProduct[];
}): JSX.Element | null {
  const { spaceId, data, membershipProducts } = props;

  const hasLiveModule = useMemo(
    () => membershipProducts.some((p) => p.productKind === "live"),
    [membershipProducts]
  );
  const hasViewpointModule = useMemo(
    () => membershipProducts.some((p) => p.productKind === "viewpoint"),
    [membershipProducts]
  );
  const viewpointSpaceProductId = useMemo(() => {
    const fromViewpoint = membershipProducts.find((p) => p.productKind === "viewpoint");
    return fromViewpoint?.spaceProductId?.trim() || null;
  }, [membershipProducts]);

  if (data == null) {
    return null;
  }

  const live = hasLiveModule ? data.live : null;
  const viewpoint = hasViewpointModule ? data.latestViewpoint : null;
  const courses = data.courses ?? [];

  const hasAny = live != null || viewpoint != null || courses.length > 0;
  if (!hasAny) {
    return null;
  }

  return (
    <div className="space-home-feed">
      {live != null ? <SpaceHomeLivePreview live={live} /> : null}
      {courses.length > 0 ? (
        <SpaceHomeCoursePreview spaceId={spaceId} courses={courses} />
      ) : null}
      {viewpoint != null ? (
        <SpaceHomeViewpointPreview
          spaceId={spaceId}
          viewpoint={viewpoint}
          fallbackSpaceProductId={viewpointSpaceProductId}
        />
      ) : null}
    </div>
  );
}
